import { z } from 'zod';

/**
 * Environment variable schema validation
 */
const envSchema = z.object({
  VITE_ENV: z
    .enum(['development', 'staging', 'production'])
    .default('development'),
  VITE_API_DOMAIN: z.string().url(),
  VITE_WEBSITE_DOMAIN: z.string().url(),
});

/**
 * Parsed and validated environment variables
 */
export const env = envSchema.parse(import.meta.env);

interface Settings {
  apiDomain: string;
  websiteDomain: string;
  emailConfirmationMode: 'REQUIRED' | 'OPTIONAL';
  sentryDsn: string;
  environment: 'development' | 'staging' | 'production';
}

export const settings: Settings = {
  apiDomain: import.meta.env.VITE_API_DOMAIN || 'http://localhost:8000',
  websiteDomain: import.meta.env.VITE_WEBSITE_DOMAIN || 'http://localhost:5173',
  emailConfirmationMode:
    (import.meta.env
      .VITE_EMAIL_CONFIRMATION_MODE as Settings['emailConfirmationMode']) ||
    'OPTIONAL',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  environment:
    (import.meta.env.VITE_ENVIRONMENT as Settings['environment']) ||
    'development',
};
